import { UserData } from '@/interfaces/types';
import { userRequests } from '@/requests/userRequests';
import { defineStore } from 'pinia';

export const userData = defineStore('user', {
    state: () => ({
      user: {} as UserData,
      userMenu: [{
          label: "",
          items: [
            {
              label: "Policy",
              translation: "policy",
              to: "/dashboard/profileUser"
            },
            {
              label: "Password",
              translation: "password",
              to: "changePassword"
            }
          ]
      }],
      loadingDevices: false
    }),

    actions: {
      translateUserMenu(t: (key: string) => string) {
          this.userMenu[0].label = ""
          this.userMenu[0].items[0].label = t('myProfile.policy')
          this.userMenu[0].items[1].label = t('myProfile.password')
      },
      
      async getAddOnLink(): Promise<string> {
        const { getProductLink, getDate } = userRequests()

        const d = await getDate()
        if(!d){
          console.log("no date for getAddOnLink")
          return ""
        }
        let now = new Date(d)
        let month = this.getMonthBetween(now, new Date(this.user.license_expire_at))
        if(month === -1) {
          console.log("wrong month for getAddOnLink")
          return ""
        }
        const link = await getProductLink(month)
        if(!link) {
          console.log("no link for getAddOnLink")
        }
        return link ?? ""
      },

      // method duplication in BE cronJobs.ts => getMonthBetween
      getMonthBetween(startDate: Date, endDate: Date): number {
        if(!startDate  || !endDate) return -1

        let millisStart = startDate.getTime()
        let millisEnd = endDate.getTime()
        let diff = millisEnd - millisStart

        // days
        diff = diff / 1000 / 60 / 60 / 24
        // month = days / (avg days in month)
        diff = diff / 30.44
        diff = Math.floor(diff)
        
        if(diff === 0) return 1
        return diff
      }
    },
    persist: true
});